import { Component } from '@angular/core';
import { AppService } from '../../app.service';
import {
    BandwidthIntegration,
    BandwidthIntegrationMobileNumber,
    SendGridIntegration,
    TelgorithmIntegration,
    TelgorithmIntegrationMobileNumber,
    TwilioIntegration,
} from './interfaces/config-platform-config.interface';
import { CommsPlatformConfigService } from '../../services/comms-platform-config/comms-platform-config.service';
import { catchError, finalize, tap } from 'rxjs';
import { isArrayWithData } from '../../utilities/array.helpers';

const CONFIG_TITLES = {
    BANDWIDTH_MOBILE_NUMBER: 'Bandwidth Mobile Number',
    BANDWIDTH_CONFIG: 'Bandwidth Config',
};

const SIDEBAR_OPERATIONS = {
    ADD: 'Add New',
    EDIT: 'Edit',
};

@Component({
    selector: 'comms-platform-config',
    templateUrl: './comms-platform-config.component.html',
    styleUrl: './comms-platform-config.component.css',
})
export class CommsPlatformConfigComponent {
    CONFIG_TITLES = CONFIG_TITLES;
    public selectedCreditorId: string = '';
    public sms: any | null;
    public email: any | null;

    public smsPlatformTypeList: any | null = null;
    public filteredSmsPlatformTypeList: any | null = null;

    public emailPlatformTypeList: any | null = null;
    public filteredEmailPlatformTypeList: any | null = null;

    bandwidthConfig: BandwidthIntegration = {} as BandwidthIntegration;
    bandwidthConfigMobileNumbers: BandwidthIntegrationMobileNumber[] = [];

    //for mobile ===========================>
    sidebarTitle: string = '';
    idToDelete: any;
    idToEdit: any;

    isSidebarVisible: boolean = false;
    sidebarOperation: string = SIDEBAR_OPERATIONS.ADD;
    sidebarMobileNumber: string = '';
    sidebarIsEnabled: boolean = true;
    //<=======================================

    isDeleteModalVisible: boolean = false;
    isDeleteMobileModalVisible: boolean = false;
    activeIndex: number = 0;

    twilio: TwilioIntegration = {} as TwilioIntegration;
    telgorithm: TelgorithmIntegration = {} as TelgorithmIntegration;
    sendGrid: SendGridIntegration = {} as SendGridIntegration;

    telgorithmMobileNumbers: TelgorithmIntegrationMobileNumber[] = [];

    public constructor(
        public appService: AppService,
        private commsPlaformConfigService: CommsPlatformConfigService,
    ) {}

    ngOnInit() {}

    onChangeTab = (event: any) => {
        if (this.selectedCreditorId) {
            this.readIntegration();
        }
    };

    onSelectCreditor(creditor: any) {
        this.selectedCreditorId = creditor.CreditorId;
        this.readIntegration();
    }

    readIntegration = () => {
        this.appService.isShowPageSpinner = true;
        switch (this.activeIndex) {
            case 0:
                this.readTwilioIntegration();
                break;
            case 1:
                this.readTelgorithmIntegration();
                break;
            case 2:
                this.readSendgridIntegration();
                break;
        }
    };

    readTwilioIntegration = () => {
        this.commsPlaformConfigService
            .getIntegrationByCreditorId(
                parseInt(this.selectedCreditorId),
                'twilio',
            )
            .pipe(
                tap((res: any) => {
                    this.isSaveTwilioClicked = false;
                    if (!!res && res.TwilioIntegrationId > 0) {
                        this.twilio = res;
                    } else {
                        this.twilio = {} as TwilioIntegration;
                        this.appService.showCommonMessageDialog(
                            'No Config',
                            'There is no Twilio Integration for this creditor.',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    readTelgorithmIntegration = () => {
        this.commsPlaformConfigService
            .getIntegrationByCreditorId(
                parseInt(this.selectedCreditorId),
                'telgorithm',
            )
            .pipe(
                tap((res: any) => {
                    this.isSaveTelgoClicked = false;
                    if (!!res && res.TelgorithmIntegrationId > 0) {
                        this.telgorithm = res;
                        this.readTelgorithmMobileNumbers();
                    } else {
                        this.telgorithm = {} as TelgorithmIntegration;
                        this.appService.showCommonMessageDialog(
                            'No Config',
                            'There is no Telgorithm Integration for this creditor.',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    readTelgorithmMobileNumbers = () => {
        this.commsPlaformConfigService
            .getMobileNumbersById(
                this.telgorithm.TelgorithmIntegrationId,
                'telgorithm-mobile',
            )
            .pipe(
                tap((res: any) => {
                    if (isArrayWithData(res)) {
                        this.telgorithmMobileNumbers = res;
                    } else {
                        this.telgorithmMobileNumbers = [];
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    readSendgridIntegration = () => {
        this.commsPlaformConfigService
            .getIntegrationByCreditorId(
                parseInt(this.selectedCreditorId),
                'sendgrid',
            )
            .pipe(
                tap((res: any) => {
                    this.isSaveSendGridClicked = false;
                    if (!!res && res.SendGridIntegrationId > 0) {
                        this.sendGrid = res;
                    } else {
                        this.sendGrid = {} as SendGridIntegration;
                        this.appService.showCommonMessageDialog(
                            'No Config',
                            'There is no SendGrid Integration for this creditor.',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    readBandwidthIntegration = () => {
        this.commsPlaformConfigService
            .getIntegrationByCreditorId(
                parseInt(this.selectedCreditorId),
                'bandwidth',
            )
            .pipe(
                tap((res: any) => {
                    console.log('Bandwidth res:', res);

                    if (!!res && res.BandwidthIntegrationId > 0) {
                        this.bandwidthConfig = res;
                    } else {
                        this.appService.showCommonMessageDialog(
                            'No Config',
                            'There seems to be no Bandwidth Integration.',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    createTwilioIntegration = () => {
        this.commsPlaformConfigService
            .createIntegration(
                parseInt(this.selectedCreditorId),
                'twilio',
                this.twilio,
            )
            .pipe(
                tap((res: any) => {
                    if (!!res?.Value?.Id) {
                        this.twilio.TwilioIntegrationId = res.Value.Id;
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Twilio Integration has been created successfully.',
                        );
                    } else {
                        throw new Error(
                            'Twilio Integration Creation error: No id returned',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    createTelgorithmIntegration = () => {
        this.commsPlaformConfigService
            .createIntegration(
                parseInt(this.selectedCreditorId),
                'telgorithm',
                this.telgorithm,
            )
            .pipe(
                tap((res: any) => {
                    if (!!res?.Value?.Id) {
                        this.telgorithm.TelgorithmIntegrationId = res.Value.Id;
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Telgorithm Integration has been created successfully.',
                        );
                    } else {
                        throw new Error(
                            'Telgorithm Integration Creation error: No id returned',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    createTelgorithmIntegrationMobileNumber = () => {
        this.commsPlaformConfigService
            .createMobileNumber(
                this.telgorithm.TelgorithmIntegrationId,
                'telgorithm-mobile',
                {
                    TelgorithmIntegrationMobileNumberId: 0,
                    MobileNumber: this.sidebarMobileNumber,
                    IsDisabled: !this.sidebarIsEnabled,
                },
            )
            .pipe(
                tap((res: any) => {
                    if (!!res?.Value?.Id) {
                        this.telgorithmMobileNumbers.push({
                            TelgorithmIntegrationId:
                                this.telgorithm.TelgorithmIntegrationId,
                            TelgorithmIntegrationMobileNumberId: res.Value.Id,
                            MobileNumber: this.sidebarMobileNumber,
                            IsDisabled: !this.sidebarIsEnabled,
                        });
                        this.isSidebarVisible = false;
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Telgorithm Integration Mobile Number has been created successfully.',
                        );
                    } else {
                        throw new Error(
                            'Telgorithm Integration Mobile Number Creation error: No id returned',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    createSendgridIntegration = () => {
        this.commsPlaformConfigService
            .createIntegration(
                parseInt(this.selectedCreditorId),
                'sendgrid',
                this.sendGrid,
            )
            .pipe(
                tap((res: any) => {
                    if (!!res?.Value?.Id) {
                        this.sendGrid.SendGridIntegrationId = res.Value.Id;
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'SendGrid Integration has been created successfully.',
                        );
                    } else {
                        throw new Error(
                            'SendGrid Integration Creation Error: No id returned',
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    updateTwilioIntegration = () => {
        this.commsPlaformConfigService
            .updateIntegration(this.twilio, 'twilio')
            .pipe(
                tap((res: any) => {
                    if (res.IsSuccess) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Twilio Integration has been updated successfully.',
                        );
                    } else {
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res?.Error?.Description,
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    updateTelgorithmIntegration = () => {
        this.commsPlaformConfigService
            .updateIntegration(this.telgorithm, 'telgorithm')
            .pipe(
                tap((res: any) => {
                    if (res.IsSuccess) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Telgorithm Integration has been updated successfully.',
                        );
                    } else {
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res?.Error?.Description,
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    updateTelgorithmIntegrationMobileNumber = () => {
        const newObj = {
            TelgorithmIntegrationId: this.telgorithm.TelgorithmIntegrationId,
            TelgorithmIntegrationMobileNumberId: this.idToEdit,
            MobileNumber: this.sidebarMobileNumber,
            IsDisabled: !this.sidebarIsEnabled,
        } as TelgorithmIntegrationMobileNumber;
        this.commsPlaformConfigService
            .updateIntegration(newObj, 'telgorithm-mobile')
            .pipe(
                tap((res: any) => {
                    if (res.IsSuccess) {
                        this.telgorithmMobileNumbers =
                            this.telgorithmMobileNumbers.map(
                                (i: TelgorithmIntegrationMobileNumber) => {
                                    if (
                                        i.TelgorithmIntegrationMobileNumberId ==
                                        this.idToEdit
                                    ) {
                                        return {
                                            ...i,
                                            ...newObj,
                                        };
                                    } else {
                                        return i;
                                    }
                                },
                            );
                        this.isSidebarVisible = false;

                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Telgorithm Integration Mobile Number has been updated successfully.',
                        );
                    } else {
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res?.Error?.Description,
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    updateSendGridIntegration = () => {
        this.commsPlaformConfigService
            .updateIntegration(this.sendGrid, 'sendgrid')
            .pipe(
                tap((res: any) => {
                    if (res.IsSuccess) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'SendGrid Integration has been updated successfully.',
                        );
                    } else {
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res?.Error?.Description,
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    deleteTwilioIntegration = () => {
        this.commsPlaformConfigService
            .deleteIntegration(this.twilio.TwilioIntegrationId, 'twilio')
            .pipe(
                tap((res: any) => {
                    this.appService.showCommonMessageDialog(
                        'Success',
                        'Twilio Integration has been deleted successfully.',
                    );
                    this.twilio = {} as TwilioIntegration;
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    deleteTelgorithmIntegration = () => {
        this.commsPlaformConfigService
            .deleteIntegration(
                this.telgorithm.TelgorithmIntegrationId,
                'telgorithm',
            )
            .pipe(
                tap((res: any) => {
                    this.appService.showCommonMessageDialog(
                        'Success',
                        'Telgorithm Integration Mobile Number has been deleted successfully.',
                    );
                    this.telgorithm = {} as TelgorithmIntegration;
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    deleteTelgorithmIntegrationMobileNumber = () => {
        this.commsPlaformConfigService
            .deleteIntegration(this.idToDelete, 'telgorithm-mobile')
            .pipe(
                tap((res: any) => {
                    this.appService.showCommonMessageDialog(
                        'Success',
                        'Telgorithm Integration Mobile Number has been deleted successfully.',
                    );
                    this.telgorithmMobileNumbers =
                        this.telgorithmMobileNumbers.filter(
                            (i: TelgorithmIntegrationMobileNumber) =>
                                i.TelgorithmIntegrationMobileNumberId !==
                                this.idToDelete,
                        );
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    deleteSendGridIntegration = () => {
        this.commsPlaformConfigService
            .deleteIntegration(this.sendGrid.SendGridIntegrationId, 'sendgrid')
            .pipe(
                tap((res: any) => {
                    this.appService.showCommonMessageDialog(
                        'Success',
                        'SendGrid Integration has been deleted successfully.',
                    );
                    this.sendGrid = {} as SendGridIntegration;
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    openDeleteModal = () => {
        this.isDeleteModalVisible = true;
    };

    isSaveTwilioClicked: boolean = false;
    saveTwilio = () => {
        this.isSaveTwilioClicked = true;
        if (
            !this.twilio.AccountSid ||
            !this.twilio.AuthToken ||
            !this.twilio.MessagingServiceSid
        ) {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide values for all input textboxes.',
            );
            return;
        }

        this.appService.isShowPageSpinner = true;
        if (!this.twilio.TwilioIntegrationId) {
            this.createTwilioIntegration();
        } else {
            this.updateTwilioIntegration();
        }
    };
    isSaveTelgoClicked: boolean = false;
    saveTelgorithm = () => {
        this.isSaveTelgoClicked = true;
        if (
            !this.telgorithm.BaseUrl ||
            !this.telgorithm.CompanySid ||
            !this.telgorithm.PrimaryToken ||
            this.telgorithm.ExpirationInMinutes === null ||
            this.telgorithm.ExpirationInMinutes === undefined ||
            typeof this.telgorithm.ExpirationInMinutes === 'undefined'
        ) {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide values for all input boxes.',
            );
            return;
        }

        this.appService.isShowPageSpinner = true;
        if (!this.telgorithm.TelgorithmIntegrationId) {
            this.createTelgorithmIntegration();
        } else {
            this.updateTelgorithmIntegration();
        }
    };
    isSaveSendGridClicked: boolean = false;
    saveSendGrid = () => {
        this.isSaveSendGridClicked = true;
        if (
            !this.sendGrid.ApiKey ||
            !this.sendGrid.SenderAddress ||
            !this.sendGrid.SenderFullName
        ) {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide values for all input textboxes.',
            );
            return;
        }

        this.appService.isShowPageSpinner = true;
        if (!this.sendGrid.SendGridIntegrationId) {
            this.createSendgridIntegration();
        } else {
            this.updateSendGridIntegration();
        }
    };

    onConfirmDelete = () => {
        this.appService.isShowPageSpinner = true;
        switch (this.activeIndex) {
            case 0:
                this.deleteTwilioIntegration();
                break;
            case 1:
                this.deleteTelgorithmIntegration();
                break;
            case 2:
                this.deleteSendGridIntegration();
                break;
        }
    };

    onConfirmDeleteMobile = () => {
        this.deleteTelgorithmIntegrationMobileNumber();
    };

    onAddNewMobile = () => {
        this.isSidebarVisible = true;
        this.sidebarOperation = SIDEBAR_OPERATIONS.ADD;
    };

    onEditMobile = (mobile: any, id: number) => {
        this.sidebarOperation = SIDEBAR_OPERATIONS.EDIT;
        this.idToEdit = id;
        this.sidebarMobileNumber = mobile.MobileNumber;
        this.sidebarIsEnabled = !mobile.IsDisabled;
        this.isSidebarVisible = true;
    };

    onDeleteMobile = (id: number) => {
        this.isDeleteMobileModalVisible = true;
        this.idToDelete = id;
    };

    onSaveMobileNumber = () => {
        if (!!this.sidebarMobileNumber) {
            this.appService.isShowPageSpinner = true;
            if (this.sidebarOperation === SIDEBAR_OPERATIONS.ADD) {
                this.createTelgorithmIntegrationMobileNumber();
            } else {
                this.updateTelgorithmIntegrationMobileNumber();
            }
        } else {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide a mobile nu mber.',
            );
        }
    };

    get IsTwilioEnabled(): boolean {
        return !this.twilio?.IsDisabled;
    }

    set IsTwilioEnabled(isEnabled: boolean) {
        this.twilio.IsDisabled = !isEnabled;
    }

    get isTelgorithmEnabled(): boolean {
        return !this.telgorithm?.IsDisabled;
    }

    set isTelgorithmEnabled(isEnabled: boolean) {
        this.telgorithm.IsDisabled = !isEnabled;
    }

    get IsSendGridEnabled(): boolean {
        return !this.sendGrid?.IsDisabled;
    }

    set IsSendGridEnabled(isEnabled: boolean) {
        this.sendGrid.IsDisabled = !isEnabled;
    }
}
